import { gql } from '@apollo/client';

export const DELETE_OBJECT_MUTATION = gql`
  mutation DeleteObjectMutation($id: String!) {
    deleteObject(id: $id) {
      ... on DeleteObjectSuccess {
        result
      }
      ... on ValidationError {
        errors {
          error
          path
        }
      }
    }
  }
`;
